module.exports = __webpack_public_path__ + "img/problem.b0b9bf1c.png";